import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SoundAlertService {
    private audio: HTMLAudioElement | null = null;

    constructor() {}

    /**
     * Play an alert sound dynamically by filename.
     * Example: playAlert('notification.mp3');
     * It will automatically look inside: assets/sounds/
     */
    playAlert(fileName: string): void {
        try {
            if (!fileName) {
                console.error('SoundAlertService: fileName is required.');
                return;
            }

            // Stop previous sound if still playing
            this.stop();

            const soundPath = `assets/sounds/${fileName}`;
            this.audio = new Audio(soundPath);
            this.audio.load();
            this.audio.play().catch(err => console.error('Audio play error:', err));
        } catch (err) {
            console.error('Error playing alert sound:', err);
        }
    }

    /**
     * Stop the currently playing sound.
     */
    stop(): void {
        if (this.audio) {
            this.audio.pause();
            this.audio.currentTime = 0;
            this.audio = null;
        }
    }
}
